export default __webpack_public_path__ + "static/media/edf2359d6810a31e.53f91c242f211dc55c1e5db907004c05.svg";